module.exports = __webpack_public_path__ + "img/120.8.6f5def73.png";